import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
//import { useParams } from 'react-router';
import './ConForm.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import { useParams } from 'react-router';

type ConFormParams = {
  id:string, 
  dummy:string
}

const ConForm: React.FC = () => {

 const {id, dummy} = useParams<ConFormParams>();

 const name:string = "BCON Form";

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        id : {id}

      </IonContent>
    </IonPage>
  );
};

export default ConForm;
